export default {
  title: 'Klik of sleep een bestand naar dit gebied om te uploaden',
  description: 'Ondersteunde formaten: .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Importsjabloon downloaden',
  },
  toasts: {
    error: 'Uploaden van bestand mislukt',
  },
};
